import { useEffect, useRef } from 'react';

export const usePolling = (callback, intervalMs, enabled) => {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled || !intervalMs) return undefined;

    const id = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) return;
      savedCallback.current();
    }, intervalMs);

    return () => clearInterval(id);
  }, [enabled, intervalMs]);
};
